import { createContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { responseInterceptor } from "../api/axios";

import axios from "../api/axios";
import config from '../config/configJS';
import {useMsal} from "@azure/msal-react";
import { applyUserLanguage } from "../services/language";

const AuthContext = createContext({});

export const AuthProvider = ({children}) => {

    const [auth, setAuth] = useState({});       
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/"; 
    const [working, setWorking] = useState(true);
    const [authConfig, setAuthConfig] = useState(null);

    const { instance } = useMsal();

    const _setAuthFromUser = (data) => {
        applyUserLanguage(data);   // jazyk z účtu (ak si ho používateľ zvolil) — aj po zmazaní cookies
        setAuth({
            uid: data.id,
            ufn: data.userFirstname,
            uln: data.userLastname,
            uem: data.userEmail,
            uia: data.isActive,
            uri: data.roleId,
            uam: data.authMethod,
            uac: data.accesses
        });
    };

    // Ktoré metódy prihlásenia sú zapnuté — riadi BE (config.json -> /api/auth/Config).
    const loadAuthConfig = async () => {
        try {
            const res = await axios.get('/api/auth/Config', { withCredentials: true });
            return res.data;
        } catch (e) {
            // Fallback zo statického configJS, ak endpoint nie je dostupný (starší BE).
            return {
                methods: {
                    local: !!config.jwtAllowed,
                    ldap: !!config.jwtAllowed,
                    windows: false,
                    azure: !!config.adAllowed,
                },
                default: config.adAllowed ? 'azure' : 'local',
            };
        }
    };

    const hydrateFromCookie = async () => {
        try {
            const response = await axios.post('/api/auth/GetUserByCookie', {}, { withCredentials: true });
            if (response.status === 200 && response.data && response.data.id) {
                _setAuthFromUser(response.data);
                return true;
            }
        } catch (e) {
            // žiadna platná session
        }
        return false;
    };

    // Windows SSO: IIS pošle identitu v hlavičke, BE vydá JWT. Skúša sa len ak je zapnuté.
    const tryWindowsSso = async () => {
        try {
            await axios.post('/api/auth/Windows', {}, { withCredentials: true });
            return await hydrateFromCookie();
        } catch (e) {
            return false;
        }
    };

    const bootstrap = async () => {
        setWorking(true);
        const cfg = await loadAuthConfig();
        setAuthConfig(cfg);
        try {
            let ok = await hydrateFromCookie();
            if (!ok && cfg && cfg.methods && cfg.methods.windows) {
                ok = await tryWindowsSso();
            }
        } catch (bootstrapError) {
            console.log("Error bootstrapping authentication:", bootstrapError);
        } finally {
            setWorking(false);
        }
    };

    const logoutUser = () => {
        localStorage.removeItem('userPhoto');
        axios.post(config.endPoint + "/api/auth/LogOut", {}, {
            withCredentials: true
        })
        .then(async () => {
            if (!!instance && instance.getAllAccounts().length > 0) {
                console.log('logging out MSAL');
                await instance.logout();
            }
            setWorking(true);
            navigate('/Login');
        })
        .catch((error) => {
            console.log(error);
        });
    };


    useEffect(() => {
        if (!auth.uid) {                       
            setWorking(true);
            axios.interceptors.response.eject(responseInterceptor);
            bootstrap();
        } else {
            console.log('auth uid not null');
            return;
        }     
    },[]); 

    return (
        <AuthContext.Provider value={{ auth, setAuth, authConfig }}>
            {!working ? children : null }
        </AuthContext.Provider>
    );
};

export default AuthContext;